import React from 'react';
import { Box, Flex, Text, VStack, Button, SimpleGrid, Heading } from '@chakra-ui/react';
import { useOrg } from '../../context/OrgContext';

function Field({ label, value, editable }) {
  return (
    <Box>
      <Text fontSize="xs" color="gray.500" mb={1.5}>{label}</Text>
      <Box
        fontSize="sm"
        color={editable ? 'gray.900' : 'gray.700'}
        border="1px solid"
        borderColor={editable ? 'gray.200' : 'transparent'}
        bg={editable ? 'white' : 'gray.50'}
        borderRadius="lg"
        px={3}
        py={2.5}
      >
        {value}
      </Box>
    </Box>
  );
}

export default function OrganisationTab() {
  const { org, canManage, isOwner } = useOrg();

  return (
    <VStack align="stretch" spacing={5}>
      <Box bg="white" border="1px solid" borderColor="gray.200" borderRadius="16px" p={{ base: 4, md: 6 }}>
        <Heading size="sm" color="gray.900" mb={4}>Organisation profile</Heading>
        <SimpleGrid columns={{ base: 1, sm: 2 }} spacing={4} maxW="460px">
          <Field label="Name" value={org.name} editable={canManage} />
          <Field label="URL slug" value={org.slug} editable={canManage} />
          <Field label="Plan" value={org.plan} editable={false} />
          <Field label="Data region" value="EU (Frankfurt)" editable={false} />
        </SimpleGrid>
        {canManage && (
          <Flex gap={2.5} mt={5}>
            <Button size="sm">Save changes</Button>
            <Button size="sm" variant="outline">Cancel</Button>
          </Flex>
        )}
      </Box>

      {isOwner && (
        <Box bg="white" border="1px solid" borderColor="status.failBg" borderRadius="16px" p={{ base: 4, md: 6 }}>
          <Heading size="sm" color="status.failText" mb={1}>Danger zone</Heading>
          <Text fontSize="xs" color="gray.500" mb={4}>Only the Owner can transfer ownership or delete the organisation.</Text>
          <Flex gap={2.5}>
            <Button size="sm" variant="outline">Transfer ownership</Button>
            <Button size="sm" variant="outline" color="status.failText" borderColor="status.failBg" _hover={{ bg: 'status.failBg' }}>
              Delete organisation
            </Button>
          </Flex>
        </Box>
      )}
    </VStack>
  );
}
